__turbopack_context__.v({
  "controls": "ClientLogoMarquee-module__Cy2z4a__controls",
});
